/* ============================================================
   WildKind Smile skin — recolors the Smile.io loyalty launcher
   and panel from Smile's default purple to WildKind amber.
   The Smile 'lite' frames are same-origin injected iframes, so
   we can restyle them safely. Everything is wrapped in try/catch
   and touches ONLY elements painted in Smile's default purple.
   ============================================================ */
(function () {
  'use strict';
  var AMBER = '#F5A623';
  var AMBER_HOVER = '#D98E0B';
  var DARK = '#3A2A00';
  var PURPLES = ['rgb(101, 104, 254)', 'rgb(83, 86, 234)', 'rgb(92, 95, 245)'];

  function isPurple(v) {
    return v && PURPLES.indexOf(v) !== -1;
  }

  function paintDoc(doc, isLauncher) {
    if (!doc || !doc.body) return;
    var els = doc.querySelectorAll('*');
    var n = Math.min(els.length, 800);
    for (var i = 0; i < n; i++) {
      var el = els[i];
      var cs;
      try { cs = doc.defaultView.getComputedStyle(el); } catch (e) { continue; }
      if (!cs) continue;
      if (isPurple(cs.backgroundColor)) {
        el.style.setProperty('background-color', AMBER, 'important');
        el.style.setProperty('color', DARK, 'important');
      }
      if (isPurple(cs.color) && !isPurple(cs.backgroundColor)) {
        el.style.setProperty('color', '#B8791A', 'important');
      }
      if (isPurple(cs.borderTopColor)) {
        el.style.setProperty('border-color', AMBER, 'important');
      }
      if (isPurple(cs.fill)) {
        el.style.setProperty('fill', DARK, 'important');
      }
    }
    if (isLauncher) {
      var btn = doc.querySelector('button');
      if (btn) {
        btn.style.setProperty('background-color', AMBER, 'important');
        btn.addEventListener('mouseenter', function () {
          btn.style.setProperty('background-color', AMBER_HOVER, 'important');
        });
        btn.addEventListener('mouseleave', function () {
          btn.style.setProperty('background-color', AMBER, 'important');
        });
        var img = btn.querySelector('img');
        if (img) img.style.setProperty('filter', 'brightness(0) saturate(100%)', 'important');
      }
    }
  }

  function tick() {
    try {
      var frames = document.querySelectorAll('iframe[id^="smile"]');
      for (var i = 0; i < frames.length; i++) {
        var doc = null;
        try { doc = frames[i].contentDocument; } catch (e) { doc = null; }
        if (doc) paintDoc(doc, frames[i].id.indexOf('launcher') !== -1);
      }
    } catch (err) { /* never break the page */ }
  }

  var iv = window.setInterval(tick, 1200);
  window.addEventListener('beforeunload', function () { window.clearInterval(iv); });
  tick();
})();
